import router from '@/router'
import MainAPI from '@/api/main'
import ProductAPI from '@/api/product'
import { isLogin } from '@/utils'

const goToNexonHome = () => (location.href = '//nexon.com')

/**
 * 상점을 구성하기 위한 기본 정보를 요청한다.
 * @param {*} param0
 */
const getInitData = ({ commit, getters, dispatch }) => {
  let shopName = router.options.base
  let nation = 'kr'

  if (shopName.split('/').length > 1) {
    // kr, jp 잘라냄
    // 라우터 패스에서 레거시 url에 모두 설정하기 때문에 신규 url만 체킹하면 됨.
    const splitShopName = shopName.split('/')
    shopName = splitShopName[1]
    nation = splitShopName[0]
  }

  if (shopName) {
    MainAPI.getInitData(shopName, responseData => {
      if (responseData.data.categoryList) {
        responseData.data.categoryList.sort(function(l, r) {
          return l.categoryOrder - r.categoryOrder
        })
      }

      const region = responseData.data.region

      if (region) {
        // 서버에서 내려준 kr region에서 jp로 이동 시 nexon home으로 이동
        // 서버에서 내려준 jp region에서 kr로 이동 시 nexon home으로 이동
        // invalid_shop_G05
        // const fromKrToJp = nation === 'jp' && region === 'KRPC'
        // const fromJpToKr = nation === 'kr' && region === 'JPPC'

        //https://test-shopping.nexon.com/kr/hittheworld/main
        //kr 리전에 존재하지 않는 상점 에러 출력 -> kr/intro로 이동
        if (nation === 'kr' && region === 'JPPC') {
          alert('존재하지 않는 상점 입니다.')
          location.href = `${process.env.VUE_APP_HOST}/kr/intro.html`
          return
        }

        // hittheworld 상점이고 jp 리전이 아닐 경우 강제로 jp/hittheworld/main으로 이동
        if (shopName === 'hittheworld' && nation !== 'jp') {
          location.href = `${process.env.VUE_APP_HOST}/jp/hittheworld/main`
          return
        }

        // hittheworld나 hittheworldtest 상점이 아닌데 jp 리전일 경우 강제로 jp/hittheworld/main 또는 jp/hittheworldtest/main으로 이동
        if (
          shopName !== 'hittheworld' &&
          shopName !== 'hittheworldtest' &&
          shopName !== 't800_jp' &&
          nation === 'jp'
        ) {
          location.href = `${process.env.VUE_APP_HOST}/jp/hittheworld/main`
          return
        }

        // if (fromKrToJp) {
        //   alert('존재하지 않는 상점 입니다.')
        //   location.href = `${process.env.VUE_APP_HOST}/kr/intro.html`
        //   return
        // }

        // if (fromJpToKr) {
        //   alert('存在しないショップです。')
        //   location.href = `${process.env.VUE_APP_HOST}/jp/hittheworld/main`
        //   return
        // }
      }

      commit('SET_INIT_DATA', responseData.data)
      if (isLogin()) {
        if (router.currentRoute.name !== 'my') {
          dispatch('my/getUserData', null, { root: true })
        }
        // 게임코인 상점일 경우 장바구니를 사용하지 않는다 -> 장바구니 리스트 호출 안하게 처리
        if (
          getters['paymentSystemType'] !== 2 &&
          router.currentRoute.name !== 'cart'
        ) {
          dispatch('cart/getProductListOfCart', null, { root: true })
        }
      }
    })
  } else {
    goToNexonHome()
  }
}
/**
 * 상점의 home에 노출할 데이터를 요청한다.
 * @param {*} param0
 */
const getHomeData = ({ commit, getters, dispatch }) => {
  // home <-> 카테고리간 이동 시 꼬이는 현상 때문에 추가
  if (getters['isFilledCategoryData'])
    commit('SET_CATEGORY', { page: 0, productList: [], last: false })
  if (getters['requestPossible'] || !getters['isFilledHomeData']) {
    commit('SET_HOME_DATA', {
      promotionList: [],
      collectionList: [],
      newList: []
    })
    MainAPI.getHomeData(responseData => {
      commit('SET_HOME_DATA', responseData.data)
    })
  } else if (getters['requestPossible'] === false) {
    dispatch('setRequestPossible', true)
  }
}
/**
 * 카테고리 별 제품 목록을 요청한다.
 * @param {*} param0
 * @param {Object} param1
 * @param {Number} param1.categoryId - 카테고리 ID
 * @param {Boolean} param1.reset - 초기화 여부
 */
const getProductListByCategory = (
  { commit, getters, dispatch },
  { categoryId, reset, callback }
) => {
  const { productList } = getters['category']
  if (getters['requestPossible'] || productList.length === 0) {
    if (reset) {
      commit('SET_CATEGORY', { page: 0, productList: [], last: false })
    }
    const { page, pageSize, last } = getters['category']
    if (last === false) {
      ProductAPI.getProductListByCategory(
        categoryId,
        page,
        pageSize,
        responseData => {
          commit('SET_CATEGORY', {
            page: page + 1,
            productList: responseData.data.productList || []
          })
          if (typeof callback === 'function') callback()
        }
      )
    }
  } else if (getters['requestPossible'] === false) {
    dispatch('setRequestPossible', true)
  }
}
/**
 *
 * @param {*} param0
 * @param {*} param1
 */
const getProductListByTag = (
  { commit, getters, dispatch },
  { tagName, reset }
) => {
  const { productList } = getters['tag']
  if (getters['requestPossible'] || productList.length === 0) {
    if (reset) {
      commit('SET_TAG', { page: 0, productList: [], last: false })
    }
    const { page, pageSize, last } = getters['tag']
    if (last === false) {
      ProductAPI.getProductListByTag(tagName, page, pageSize, responseData => {
        commit('SET_TAG', {
          page: page + 1,
          productList: responseData.data.productList || []
        })
      })
    }
  } else if (getters['requestPossible'] === false) {
    dispatch('setRequestPossible', true)
  }
}
/**
 * API 호출 가능 여부를 설정한다. 해당 action은 카테고리와 home에서 사용한다.
 * @param {*} param0
 * @param {Boolean} possible - 호출 가능 여부
 */
const setRequestPossible = ({ commit }, possible) => {
  commit('SET_REQUEST_POSSIBLE', possible)
}
/**
 * home 화면의 콜렉션별 추가 목록을 불러온다.
 * @param {*} param0
 * @param {*} payload
 */
const getMoreList = ({ commit }, payload) => {
  commit('GET_MORE_LIST', payload)
}

export default {
  getInitData,
  getHomeData,
  getProductListByCategory,
  getProductListByTag,
  setRequestPossible,
  getMoreList
}
